import { z } from 'zod';
import type { TeacherDto } from '../types/TeacherDto';

export const teacherDtoSchema = z.object({
  id: z.string().uuid(),
  auth0Id: z.string(),
  firstName: z.string().min(2).max(64),
  lastName: z.string().min(2).max(64),
  email: z.string().email(),
  backupEmail: z.string().email().nullable(),
  phoneNumber: z.string().nullable(),
  username: z.string().nullable(),
  avatar: z.string().nullable(),
  description: z.string().min(3).max(255).nullable(),
  timeZone: z.string().nullable(),
  password: z.string().min(8).max(32).nullable(),
  createdAt: z.string().datetime({ offset: true }),
  updatedAt: z.string().datetime({ offset: true }),
  deletedAt: z.string().datetime({ offset: true }).nullable(),
  speciality: z.string().nullable(),
  language: z
    .enum(['eng', 'fra', 'spa', 'deu', 'ita', 'ukr'])
    .default('eng')
    .optional()
    .nullable(),
  role: z.enum(['teacher']),
}) as z.ZodType<TeacherDto>;
